import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ReactDOM from "react-dom/client";
import App from "./App";
import CreditPurchaseSuccess from "./CreditPurchaseSuccess";
import { startClientVersionPolling } from "./clientVersionCheck";
import "./index.css";

startClientVersionPolling();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Main application route */}
        <Route path="/*" element={<App />} />

        {/* Route for the Stripe success page */}
        <Route path="/credits/success" element={<CreditPurchaseSuccess />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
